/**
 * @copyright 2019 @ DigiNet
 * @author TRIHAO
 * @create 2019/10/16 16:23
 * @update 2019/10/16 16:23
 */

import React from 'react';
import PropTypes from 'prop-types';
import PopUpPrint from "../../common/print/print";
import * as templateDropdownActions from "../../../actions/template-dropdown-actions";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import Config from "../../../config";
import Api from "../../../services/api";
import { Button } from 'diginet-core-ui/components';
import ButtonLoading from "./button-loading";
import {createPortal} from "react-dom";

const _initBtnLoading = {
    pdf: false,
    excel: false,
    word: false,
};

const btnProps =  { size: 'small', labelProps: { style: { color: 'initial' } } };
class ButtonExport extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showPopupPrint: false,
            urlExcel: '',
            download: '',
            bDisplay: true,
            isLoading: false,
            isLoadingPopup: false,
            btnLoading: _initBtnLoading,
            isImportantData: 0,
            isEditDataExport: 0,
            cboReportTemplate: [],
            loading: false
        };
        this.exportExcel = this.exportExcel.bind(this);
        this.PopUpPrintRef = null;
        this.previewPDFData = {};
    };

    onClick(mode) {
        let {param, reportTypeID, onShowPop, getParamPrint, onlyShowPopup} = this.props;
        const {cboReportTemplate} = this.state;
        if(getParamPrint){
            param = getParamPrint();
        }
        else{
            param = param ? [...param] : [];
        }
        const data = cboReportTemplate;
        if (data && data.length && data.length > 0) {
            if (data.length === 1 && !onlyShowPopup) {
                param.push({type: "Varchar", id: "ReportID", value: data[0].ReportID});
                const options = {
                    reportURL: data[0].URL,
                    reportID: data[0].ReportID,
                    reportName: data[0].FileName,
                    reportTypeID: reportTypeID,
                    isPDF: mode === 1 ? 1 : 0,
                    exportType: mode === 1 ? "pdf" : (data[0].FileExt ? data[0].FileExt.replace(".", "") : ""),
                    strSQL: data[0]?.StrSQL ? data[0]?.StrSQL : "",
                    fileExt: data[0].FileExt ? data[0].FileExt.replace(".", "") : ""
                };
                this.exportExcel(param, options, false);
            } else {
                this.setState({showPopupPrint: true}, () => {
                    onShowPop && onShowPop();
                });
            }
        } else {
            Config.popupCore.show('INFO', Config.lang("CRM_Ban_chua_thiet_lap_Mau_bao_cao"));
        }
    }

    loadReportType = () => {
        const param = {
            ReportTypeID: this.props.reportTypeID
        };
        this.props.templateDropdownActions.cboReportType(param, (error, data) => {
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data && data.length > 0) {
                this.setState({
                    isImportantData: data[0].IsImportantData ? data[0].IsImportantData : 0,
                    isEditDataExport: data[0].IsEditDataExport ? data[0].IsEditDataExport : 0
                });
            }
        });
    };

    previewTemplate = (ID, cb) => {
        if (!ID) return;
        let url = Config.env.api + "/report/preview?";
        const params = {
            token: Config.token.id,
            id: ID
        };
        let param = Object.keys(params).map(function (k) {
            return k + "=" + params[k];
        }).join("&");
        url = url + encodeURIComponent(param);
        if (cb) cb(url);
    };

    beforePreviewTemplate = (param, options, cb) => {
        const params = this.getParamsPreviewExport(param, options);
        this.setState({ btnLoading: true });
        this.props.templateDropdownActions.passParametersExport(params, (error, data) => {
            this.setState({ btnLoading: false });
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (data.id && cb) this.previewTemplate(data.id, cb);
            }
        });
    };

    componentDidMount() {
        this.loadReportType();
        this.loadData();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.reportTypeID !== this.props.reportTypeID) {
            this.loadReportType();
            this.loadData();
        }
    }

    loadData() {
        const param = {
            ReportTypeID: this.props.reportTypeID
        };
        this.props.templateDropdownActions.cboReportTemplate(param, (error, data) => {
            this.setState({
                loading: true
            });
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            }
            this.setState({
                cboReportTemplate: data
            })
        }, 1);
    }

    getParamsPreviewExport = (param, options, exportType) => {
        if (options && this.props.FormID) {
            options.reportTypeID = this.props.FormID
        }
        if (options && options.exportType) {
            this.setState({
                btnLoading: {
                    pdf: options.exportType === "pdf",
                    excel: options.exportType === "xlsx" || options.exportType === "xls",
                    word: options.exportType === "docx" || options.exportType === "docx"
                }
            });
        }
        return {
            "TemplateURL": options.reportURL,
            "ReportFileName": options.reportID,
            "isPDF": options.isPDF,
            "StoreParams": JSON.stringify(param),
            "ExportType": exportType || options?.exportType || "xlsx",
            "FileExt": options?.fileExt || "xlsx",
            "strSQL": options?.strSQL || "",
        };
    };

    exportExcel(param, options, popup, isPreview, cb) {
        if (this.state.isLoading) return;
        if (isPreview && this.previewPDFData?.[options?.reportID]) {
            if (Object.hasOwn(this.PopUpPrintRef || {}, 'onPreview')) this.PopUpPrintRef.onPreview(true, this.previewPDFData[options.reportID], 'pdf');
            return;
        }
        this.setState({
            isLoading: !popup,
            isLoadingPopup: popup
        });
        const params = this.getParamsPreviewExport(param, options, isPreview ? 'pdf' : '');
        let url = Config.env.api + "/report/export";
        const data = {
            method: 'PUT',
            headers: Api.headers(),
            body: JSON.stringify(params)
        };
        const reportID = options?.reportID || '';
        fetch(url, data)
            .then(response => {
                cb && cb();
                let content_dispostion = response.headers.get('Content-Disposition');
                if (content_dispostion) {
                    content_dispostion = content_dispostion ? content_dispostion.split('filename=') : '';
                    const filename = content_dispostion.length > 1 ? content_dispostion[1] : 'report-filename.xlsx';
                    this.setState({
                        download: filename.replace(/"/g, '')
                    });
                    return response.blob();
                } else {
                    return response.json();
                }
            })
            .then((result) => {
                if (!result.code) {
                    cb && cb();
                    const objectURL = URL.createObjectURL(result);
                    const {id} = this.props;
                    if (isPreview) this.previewPDFData = { ...this.previewPDFData, [reportID]: objectURL };
                    this.setState({
                        urlExcel: objectURL,
                        isLoading: false,
                        isLoadingPopup: false,
                        btnLoading: _initBtnLoading
                    });
                    if (isPreview) {
                        if (Object.hasOwn(this.PopUpPrintRef || {}, 'onPreview')) this.PopUpPrintRef.onPreview(true, objectURL, 'pdf');
                    } else {
                        let el = document.getElementById(`${id ? id : ''}linkExportExcel_1`);
                        el.click();
                        this.props.onDownloadComplete && this.props.onDownloadComplete();
                    }
                } else {
                    cb && cb();
                    let message = Config.lang("CRM_Loi_chua_xac_dinh");
                    switch (result.code) {
                        case "EXP001":
                            message = Config.lang("CRM_Khong_co_du_lieu");
                            break;
                        case 'F4000E007':
                            message = Config.lang("CRM_Ban_chua_chon_mau_bao_cao");
                            break;
                        default :
                            message = result.message;
                            break;
                    }
                    this.setState({
                        isLoading: false,
                        isLoadingPopup: false,
                        btnLoading: _initBtnLoading
                    });
                    Config.popupCore.show("INFO", message);
                }
            })
            .catch((err) => {
                cb && cb();
                this.setState({
                    isLoading: false,
                    isLoadingPopup: false,
                    btnLoading: _initBtnLoading
                });
                Config.popupCore.show("ERROR", err);
            });
    }

    render() {
        let { name, className, disabled, reportTypeID, param, hideButton, id, onHidePop, showBtnPrint,
            getParamPrint, onlyShowPopup, btnWord, btnPDF, btnExcel, isPreview, isViewPDF, isCoreUI, FormID
        } = this.props;
        let {cboReportTemplate, loading, isImportantData, isEditDataExport, btnLoading, isLoading} = this.state;
        const displayButtonExcel = !(isImportantData === 1 && isEditDataExport === 0);
        /*
         * lƯU Ý KHI GẮN VÀO LƯỚI NÚT HAMBURGER
         *khi gắn vào btnHamburger thì phải disabled 1 nút. hiện tại có trường hợp đổ cùng lúc 2 nút pdf và excel ví dụ màn hình W20F1000
         * phải tách rời ra 2 btn riêng,
         * NAME CỦA NÚT EXCEL, PDF VÀ NAME CỦA NÚT XUẤT DỮ LIỆU PHẢI GIỐNG NHAU
         * */
        const _disabled = !!Object.keys(btnLoading).find(l => btnLoading[l]);
        return (
            <span id={'popupPrint'}>
                {!loading && <ButtonLoading hideText={true}
                                            disabled={true}
                                            name={name}/>}
                {this.state.showPopupPrint &&
                    createPortal(<PopUpPrint
                        FormID={FormID}
                        ref={ref => this.PopUpPrintRef = ref}
                        isViewPDF={isViewPDF}
                        hideBtnExcel={hideButton ? hideButton !== 'all' && hideButton !== 'excel' : displayButtonExcel}
                        hideBtnPdf={hideButton !== 'all' && hideButton !== 'pdf'}
                        // popupprint hideBtnExcel hideBtnPdf  = true thì hiện false thì ẩn, code cũ không sửa
                        reportTypeID={reportTypeID}
                        onExportExcel={(param, options, _, isPreview, cb) => this.exportExcel(param, options, true, isPreview, cb)}
                        param={getParamPrint ? getParamPrint() : param}
                        btnLoading={this.state.btnLoading}
                        onHide={() => {
                        this.setState({showPopupPrint: false}, () => {
                                onHidePop && onHidePop();
                            });
                        }}
                        beforePreviewTemplate={this.beforePreviewTemplate}
                        isPreview={isPreview}
                    />, document.getElementById('root'))
                }
                {cboReportTemplate && cboReportTemplate.length === 1 && hideButton !== 'all' && !onlyShowPopup
                    && (
                        <div className={'jus-end'}>
                            {hideButton !== 'pdf' && cboReportTemplate[0].IsConvertPDF === 1 &&
                                <Button
                                    {...btnProps}
                                    color={'danger'}
                                    startIcon={"Pdf"}
                                    className={'mgl1x'}
                                    disabled={_disabled || disabled}
                                    label={Config.lang('Xuat_PDF')}
                                    loading={btnLoading?.pdf || false}
                                    onClick={() => this.onClick(1)}
                                    {...btnPDF}
                                />}
                            {hideButton !== 'excel' && displayButtonExcel && cboReportTemplate[0].ReportType === "Excel" &&
                                <Button
                                    {...btnProps}
                                    color={'success'}
                                    startIcon={"Sheet"}
                                    className={'mgl1x'}
                                    disabled={_disabled || disabled}
                                    label={Config.lang('Xuat_Excel')}
                                    loading={btnLoading?.excel || false}
                                    onClick={() => this.onClick(0)}
                                    {...btnExcel}
                                />}
                            {hideButton !== 'word' && cboReportTemplate[0].ReportType === "Word" &&
                                 <Button
                                    {...btnProps}
                                    color={'info'}
                                    startIcon={"Sheet"}
                                    className={'mgl1x'}
                                    disabled={_disabled || disabled}
                                    label={Config.lang('Xuat_word')}
                                    loading={btnLoading?.word || false}
                                    onClick={() => this.onClick(2)}
                                    {...btnWord}
                                />}
                        </div>
                    )}
                {((cboReportTemplate && (cboReportTemplate.length > 1 || (cboReportTemplate.length > 0 && onlyShowPopup))) || showBtnPrint) &&
                    <Button  
                        {...(isCoreUI ? {} : btnProps)}
                        color={'primary'}
                        loading={isLoading} 
                        disabled={disabled}
                        startIcon={'Printer'}
                        className={className}
                        onClick={() => this.onClick()}
                        label={name} />}
                <a id={`${id ? id : ''}linkExportExcel_1`}
                    className='hide'
                    download={this.state.download}
                    href={this.state.urlExcel}>File</a>
            </span>
        );
    }
}

ButtonExport.defaultProps = {
    isPreview: false,
    showBtnPrint: false
};

ButtonExport.propTypes = {
    disabled: PropTypes.bool,
    id: PropTypes.string,// nếu import button export nhiều lần cùng 1 màn hình thì phải khai báo id để không bị trùng
    startDownload: PropTypes.bool,
    endDownload: PropTypes.bool,
    onDownloadComplete: PropTypes.func,
    onHidePop: PropTypes.func,
    onShowPop: PropTypes.func,
    name: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
    reportTypeID: PropTypes.string,
    FormID: PropTypes.string,
    transTypeID: PropTypes.string,
    param: PropTypes.array,
    IsImportantData: PropTypes.number,
    IsEditDataExport: PropTypes.number,
    btnExcelName: PropTypes.string,
    hideButton: PropTypes.oneOf(['pdf', 'excel', 'all']),
    btnExcel: PropTypes.object, //{name : '', className: ''}
    btnWord: PropTypes.object, //{name : '', className: ''}
    btnPDF: PropTypes.object, //{name : '', className: ''}
    onlyShowPopup: PropTypes.bool,
    isPreview: PropTypes.bool,
    isCoreUI: PropTypes.bool,
    showBtnPrint: PropTypes.bool,
};

export default connect(null,
    (dispatch) => ({
        templateDropdownActions: bindActionCreators(templateDropdownActions, dispatch)
    }),null, {withRef: true}
)(ButtonExport);
